export enum TransactionEvent {
  CREATED = 'TL_TRANSACTION_CREATED_EVENT',
  CREATE_FAILED = 'TL_TRANSACTION_CREATE_FAILED_EVENT',
}
